<template>
  <div>
    <!-- <el-page-header @back="goBack" :content="title + '查询'" title="返回重选">
    </el-page-header> -->
    <div class="selectform">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="姓名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证">
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">成绩查询</el-button>
        </el-form-item>
      </el-form>
    </div>
   
      <div class="lqtzs"  v-if="show">
    <transition name="fade">

        <div class="lqtzsMian" v-if="transitionshow">
          <div class="closelqtzsYear" @click="show = transitionshow = false">
            <i class="el-icon-close"></i>
          </div>
          <div class="lqtzsTitle">
           海南医科大学成绩单
          </div>
          <ul>
            <template v-for="title in tableData.tableTitle">
              <li>
                  {{ title.label }}:
                  <div>
                    {{ tableData.data[0][title.value] }}
                  </div>
              </li>
            </template>
          </ul>
        </div>
    </transition>

      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        name: "",
        id: "",
      },
      title: "",
      tableData: [],
      loading: false,
      show: false,
      transitionshow: false,
      year: "",
    };
  },
  methods: {
    getenrollMsg() {},
    onSubmit() {
      this.loading = true;
      this.tableData = [];
      this.$http({
        method: "get",
        url: `/RegistrationMagt/api/ScoreQuery/AdultEduList_Self`,
        params: {
          name: this.form.name,
          idcard: this.form.id,
        },
      })
        .then((res) => {
          this.loading = false;

          console.log(res);
          if (res.data.msg == "error") {
            this.$allMethods.returnRrror(res.data.msg, res.data.response);
          } else{
            if (res.data.response.data.length != 0) {
              this.show = true;
              this.tableData = res.data.response;
              this.year = this.tableData.data[0].year;
              let that = this
              this.timer= setTimeout(function(){that.transitionshow = true}, 500);
            } else {
              this.$allMethods.returnRrror('error', '查询不到相关数据');
            }
          }
        })
        .catch((_) => {});
    },
    goBack() {
      this.$router.push("achievementIndex");
    },
  },
  created() {
    switch (this.$store.state.QStype) {
      case 0:
        this.title = "本科生录取信息";
        break;
      case 1:
        this.title = "硕士录取信息";
        break;
      case 2:
        this.title = "博士录取信息";
        break;
      case 3:
        this.title = "留学生录取信息";
        break;
      case 4:
        this.title = "成人教育录取信息";
        break;
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>
<style scoped>
.selectform {
  margin: 50px auto 20px;
  width: 500px;
  padding-right: 80px;
}

.lqtzsMian ul {
  font-weight: 700;
  list-style: none;
  font-size: 18px;
  margin: auto;
  width: 900px;
 padding: 50px;
  text-align: left;
  overflow: auto;
  color: #8c1f24;
}
.lqtzsMian ul li div {
  /* text-decoration: underline; */
  font-weight: 500;
  /* float: left; */
  width: 200px;
  display: inline;
  color: #3f3c3c;

}
.lqtzsMian ul li {
  /* text-decoration: underline; */
  /* color: #409EFF; */
  margin-bottom: 10px;
  display: inline-table;
  width: 400px;
  margin: 10px 0px;
  border-bottom: #fdf2f2 1px solid;
}
.lqtzs {
  height: 100vh;
  width: 100%;
  position:fixed;
  left: 0px;
  top: 0px;
  background: #00000066;
}
.lqtzsMian {
  width: 1000px;
  margin: 140px auto;
  /* background:white; */
  border-radius: 10px;
  background:white url("../assets/redlogo.png") no-repeat top;
  background-size: 500px auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.lqtzsTitle {
  font-size: 28px;
  font-weight: 700;
  color: #4c4747;
}
.closelqtzsYear {
  position: relative;
  left: 1030px;
  top: 0px;
  color: white;
  font-size: 30px;
  line-height: 40px;
  background: #00000030;
  height: 40px;
  width: 40px;
  cursor: pointer;
}
.closelqtzsYear :hover {
  -webkit-animation: rotation 0.2s linear;
}

/* 关闭图标旋转90度 */
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(90deg);
  }
}

.fade-enter-active {
  transition: all .3s ease;
}
.fade-leave-active {
    transform: translateY(80px);
}

.fade-leave-enter, .fade-leave-to {
  transform: translateY(80px);
}

</style>